import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  input,
  signal,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { isEqual } from 'lodash-es';
import { SpinnerComponent } from '../spinner/spinner.component';
import { saveOverlay } from './saveOverlayAnimation';

/**
 * Component that is attached to a {@link FormGroup} and is diplayed when the form groups initial value has changed to trigger an action
 */
@Component({
  standalone: true,
  selector: 'ct-lib-form-saver',
  templateUrl: './form-saver.component.html',
  styleUrls: ['./form-saver.component.scss'],
  animations: [saveOverlay],
  imports: [TranslocoPipe, SpinnerComponent],
})
export class FormSaverComponent implements AfterViewInit {
  @Input() form: UntypedFormGroup = new UntypedFormGroup({});
  /** When true, keeps the bar visible and shows a loader on the save button. */
  readonly busy = input(false);
  @Output() onSave: EventEmitter<any> = new EventEmitter();
  @Output() onDiscard: EventEmitter<any> = new EventEmitter();
  public originalValue: any;
  public shaking = signal<boolean>(false);
  public hasChanges = signal<boolean>(false);

  ngAfterViewInit(): void {
    this.form.valueChanges.subscribe({
      next: (result) => {
        this.hasChanges.set(
          this.originalValue && !isEqual(result, this.originalValue),
        );
      },
    });
  }

  updateOriginalValue() {
    this.originalValue = this.form.value;
    this.form.patchValue(this.originalValue);
  }

  discard() {
    if (this.busy()) {
      return;
    }
    this.form.patchValue(this.originalValue);
    this.onDiscard.emit();
  }

  /**
   * Emits save when the form is dirty and no save is already in flight.
   * @returns {void}
   */
  save(): void {
    if (this.busy()) {
      return;
    }
    this.onSave.emit();
  }

  shake() {
    if (this.shaking()) return;
    this.shaking.set(true);
    setTimeout(() => {
      this.shaking.set(false);
    }, 500);
  }
}
